import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ProjectsSection from './components/ProjectsSection';
import TestimonialsSection from './components/TestimonialsSection';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main>
        <HeroSection />
        
        {/* İzmir Tadilat Firması Section */}
        <section className="py-16 md:py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                İzmir'de Profesyonel Tadilat, Dekorasyon ve İç Mimarlık Çözümleri
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed">
                <p>
                  İzmir'de yaşam alanlarını yenilemek isteyenler için doğru <strong>izmir tadilat firması</strong> ile çalışmak hem maliyet hem de sonuç açısından büyük önem taşır. İzmirtadilatfirmasi.com, konut ve ticari alanlarda sunduğu profesyonel çözümlerle güven veren bir hizmet anlayışı sunar. Proje öncesinde ücretsiz keşif yapılması, ihtiyaçların net şekilde belirlenmesini sağlar. Deneyimli ve ilgili ekip, sürecin her aşamasında planlı ve şeffaf ilerler. Kullanılan malzemelerde kalite standartları ön planda tutulur. Amaç yalnızca tadilat yapmak değil, uzun yıllar sorunsuz kullanılacak alanlar oluşturmaktır. İş teslim sürelerine sadık kalınması müşteri memnuniyetini artırır. Her projede estetik ve işlevsellik dengesi gözetilir. İzmir genelinde farklı ölçekte başarılı uygulamalara imza atılmıştır.
                </p>
              </div>
            </div>
          </div>
        </section>

        <AboutSection />
        
        {/* İzmir'de Tadilat Yaptırmak İçin Güvenilir Mi? */}
        <section className="py-16 md:py-20 bg-cream">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                İzmir'de Tadilat Yaptırmak İçin izmirtadilatfirmasi.com Güvenilir Mi?
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed mb-8">
                <p>
                  İzmir'de <strong>izmir tadilat</strong> hizmeti alırken en çok dikkat edilen konu güvenilirliktir. İzmirtadilatfirmasi.com, keşiften teslimata kadar süreci profesyonel şekilde yönetir. Ücretsiz keşif sayesinde yapılacak işler ve maliyetler baştan netleşir. Bu yaklaşım, sürpriz giderlerin önüne geçer. Firma bünyesindeki ekip alanında tecrübeli ustalardan oluşur. İletişime açık ve çözüm odaklı çalışma anlayışı benimsenir. Kullanılan malzemeler hem dayanıklı hem de uzun ömürlüdür. Proje boyunca müşteriye düzenli bilgi verilir. Bu da güven duygusunu güçlendirir.
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-semibold text-wood-dark mb-6">Güven sağlayan temel unsurlar:</h3>
                <ul className="space-y-3">
                  {[
                    'Ücretsiz keşif hizmeti',
                    'Tecrübeli ve ilgili ekip',
                    'Kaliteli malzeme kullanımı',
                    'Planlı ve şeffaf süreç yönetimi'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-wood text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-sm md:text-base text-wood">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <ServicesSection />
        
        {/* İzmir Banyo Tadilatı & Fayans Modelleri */}
        <section className="py-16 md:py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                (2026) İzmir Banyo Tadilatı & Fayans Modelleri
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed mb-8">
                <p>
                  Evlerde en çok yenilenen alanların başında <strong>izmir banyo tadilat</strong> projeleri gelir. 2026 trendlerinde sade, kullanışlı ve modern tasarımlar öne çıkar. Fayans seçimleri hem estetik hem de hijyen açısından büyük önem taşır. İzmirtadilatfirmasi.com, banyolarda su yalıtımını titizlikle uygular. Doğru altyapı çalışmaları sayesinde uzun vadeli kullanım sağlanır. Alanın ölçüsüne göre en uygun yerleşim planı oluşturulur. Aydınlatma ve dolap çözümleriyle fonksiyonel alanlar elde edilir. Banyo tadilatında kalite, konforu doğrudan etkiler. Bu nedenle her detay özenle planlanır.
                </p>
              </div>
              
              <div className="bg-cream rounded-2xl p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-semibold text-wood-dark mb-6">Banyo tadilatında sunulan çözümler:</h3>
                <ul className="space-y-3">
                  {[
                    'Modern fayans uygulamaları',
                    'Duşakabin ve vitrifiye montajı',
                    'Su yalıtımı',
                    'Estetik ve kullanışlı tasarımlar'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-wood text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-sm md:text-base text-wood">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <ProjectsSection />
        
        {/* İzmir Tadilat Firmaları Arasında Doğru Seçim */}
        <section className="py-16 md:py-20 bg-cream">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                İzmir Tadilat Firmaları Arasında Doğru Seçim
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed">
                <p>
                  İzmir'de çok sayıda <strong>izmir tadilat firması</strong> bulunmasına rağmen doğru firmayı seçmek kritik bir konudur. İzmirtadilatfirmasi.com, her projeye özel yaklaşımıyla öne çıkar. Hazır çözümler yerine ihtiyaca uygun planlama yapılır. Zamanında teslim anlayışı, özellikle yaşayan alanlarda büyük avantaj sağlar. Firma, küçük çaplı yenilemelerden kapsamlı projelere kadar geniş hizmet sunar. İletişim sürecinin güçlü olması, işin sağlıklı ilerlemesini sağlar. Müşteri beklentileri proje boyunca dikkate alınır. Böylece ortaya çıkan sonuç hem estetik hem de işlevsel olur. Uzun vadeli memnuniyet hedeflenir.
                </p>
              </div>
            </div>
          </div>
        </section>

        <StatsSection />
        
        {/* İzmir Mutfak Dolabı & Anahtar Teslim Tadilat */}
        <section className="py-16 md:py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                İzmir Mutfak Dolabı & Anahtar Teslim Tadilat
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed mb-8">
                <p>
                  Mutfaklar, evin en aktif kullanılan alanlarından biridir. <strong>izmir anahtar teslim tadilat</strong> hizmetleri kapsamında mutfak dolabı uygulamaları büyük önem taşır. İzmirtadilatfirmasi.com, ölçüye özel mutfak dolabı çözümleri sunar. Kullanılan malzemeler dayanıklı ve uzun ömürlüdür. Depolama alanları verimli şekilde planlanır. Renk ve tasarım seçimleri mekâna uygun yapılır. Anahtar teslim projelerde tüm süreç tek elden yönetilir. Bu durum zaman ve maliyet avantajı sağlar. Müşteri, tüm tadilat sürecini tek firma ile sorunsuz şekilde tamamlar.
                </p>
              </div>
              
              <div className="bg-cream rounded-2xl p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-semibold text-wood-dark mb-6">Anahtar teslim tadilat avantajları:</h3>
                <ul className="space-y-3">
                  {[
                    'Tek muhatap ile süreç yönetimi',
                    'Zaman tasarrufu',
                    'Bütçe kontrolü',
                    'Planlı ve düzenli uygulama'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-wood text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-sm md:text-base text-wood">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <TestimonialsSection />
        
        {/* İzmir Çatı Tadilatı & Fiyatları */}
        <section className="py-16 md:py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">
                İzmir Çatı Tadilatı & Fiyatları (2026 Güncel)
              </h2>
              <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed">
                <p>
                  Binaların en önemli bölümlerinden biri çatıdır ve <strong>izmir çatı tadilatı</strong> profesyonel şekilde yapılmalıdır. Çatı sorunları zamanında çözülmediğinde ciddi masraflara yol açabilir. İzmirtadilatfirmasi.com, çatı onarım ve yenileme işlemlerinde kaliteli malzeme kullanır. Isı ve su yalıtımı doğru şekilde uygulanır. 2026 yılı itibarıyla fiyatlar, yapılacak işin kapsamına göre belirlenir. Ücretsiz keşif sayesinde net maliyet bilgisi sunulur. Böylece gereksiz harcamaların önüne geçilir. Sağlam ve uzun ömürlü çatı çözümleri hedeflenir. Bu da yapının değerini artırır.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default HomePage;
